import { Stack, Typography } from '@mui/material'
import { FieldError, UseFormSetValue } from 'react-hook-form'
import { DatePickerField } from 'utoniq-ui'

import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

import { SettingValues } from '../PersonalInfoForm'

type BirthdayInputCellProps = {
  value: SettingValues['birthday']
  isRequired?: boolean
  error?: FieldError
  setValue: UseFormSetValue<SettingValues>
}

export const BirthdayInputCell: Cell<BirthdayInputCellProps> = ({
  value,
  isRequired,
  error,
  setValue,
}) => {
  const { t } = useTranslation('personalInfoSettings')
  return (
    <CellFrame sx={{ pt: 6, mb: 4, position: 'relative' }}>
      <DatePickerField
        error={error}
        onChange={date => {
          setValue('birthday', date as never, {
            shouldValidate: true,
            shouldDirty: true,
          })
        }}
        value={value}
        placeholder={t('birthdayPlaceholder')}
        titleProps={{
          children: (
            <Stack direction="row" alignItems="center">
              <Typography variant="subtitle1" color="text.secondary">
                {t('birthday')}
              </Typography>
              {isRequired && (
                <Typography
                  variant="caption"
                  color="error.main"
                  component="p"
                  ml={1}
                  mt={-1}
                >
                  {t('required', '※必須')}
                </Typography>
              )}
            </Stack>
          ),
        }}
      />
    </CellFrame>
  )
}
